<template>
  <div class="g-container-p">
    <div class="m-container-p">
      <!-- 面包屑 -->
      <div class="crumbs-box-p">
        <span>匠心记</span>
        <span>&gt;</span>
        <span>创建QE报告</span>
      </div>
      <!-- 主体 -->
      <!-- 基础检查 -->
      <div class="carate-qe-main-p"
           style="margin-bottom: 30px;width:98%">
        <h2 class="create-qe-tit-p">创建QE报告</h2>
        <div class="create-title-p">
          <input type="text"
                 placeholder="请输入QE报告的正文标题"
                 v-model="title" />
        </div>
        <update-qe-upload-file class="create-cover-p"
                               ref="cover"
                               :basePicArr="picDataArr"
                               :baseFileType="baseFileType"
                               :oldExtraFileList="extraFileList"
                               @getReportDataArr="getReportDataArr"
                               style="border-bottom: none;padding-bottom: 0px;">
          <span slot="title">基础检查</span>
          <span slot="remark">上传《现场基础情况检查告知函》(图片或PDF二选一上传)&nbsp;</span>
        </update-qe-upload-file>
      </div>
      <!-- 现场标样制作 -->
      <div class="carate-qe-main-p"
           style="margin-bottom: 30px;width:98%"
           v-show="getSceneStandardMakeShow">
        <update-scene-standard-make class="material-edit-p"
                                    ref="scene"
                                    :oldSceneStandardMakeDataArr="sceneStandardMakeArr"
                                    style="padding-top: 0px;padding-bottom: 25px;margin-bottom: 20px;"
                                    @getSceneStandardMakeData="getSceneStandardMakeData">
          <span slot="title">现场标样制作</span>
        </update-scene-standard-make>

      </div>
      <!-- 原材料进场 -->
      <div class="carate-qe-main-p"
           style="margin-bottom: 30px;width:98%"
           v-show="getRawMaterialEnterShow">
        <up-raw-material-enter class="quality-edit-p"
                               ref="quality"
                               :oldRowPicDataArr="rowPicDataArr"
                               :oldRowCheckPicDataArr="rowCheckPicDataArr"
                               :oldRowCheckFileList="rowCheckFileList"
                               :rawCheckFlag="getRawMaterialCheckShow"
                               @getRowEnterDataArr="getRowEnterDataArr"
                               style="padding: 0px 20px 0px 0px;">
          <span slot="title">原材料进场</span>
          <template slot="radioInfo">
            <template>
              <el-radio-group v-model="rowRadioValue"
                              text-color="#626aef"
                              size="small"
                              fill="rgb(239, 240, 253)"
                              style="margin-bottom:1%;margin-top: 0.5%;">
                <el-radio border
                          :label=1>良好</el-radio>
                <el-radio border
                          :label=2>预警</el-radio>
                <el-radio border
                          :label=3>异常</el-radio>
              </el-radio-group>
            </template>
            <div class="create-title-p"
                 style="margin: 0px;padding-bottom: 10px;">
              <input type="text"
                     placeholder="描述"
                     v-model="rowRadioRemark" />
            </div>
          </template>
          <template slot="checkInfo">
            <div class="create-title-p">
              <input type="text"
                     placeholder="请输入送检检测机构名称"
                     v-model="checkInstitutionName" />
            </div>
            <div class="create-title-p">
              <input type="text"
                     placeholder="请输入检测结果描述"
                     v-model="checkResult" />
            </div>
          </template>
        </up-raw-material-enter>
      </div>
      <!-- 施工过程管控 -->
      <div class="carate-qe-main-p"
           style="margin-bottom: 30px;width:98%"
           v-show="getConControlNodeShow">
        <update-con-control-node class="material-edit-p"
                                 ref="material"
                                 :oldConControlDataArr="constructionControlDataArr"
                                 style="padding-top: 0px;padding-bottom: 25px;margin-bottom: 20px;"
                                 @getConstructionControlData="getConstructionControlData">
          <span slot="title">施工过程管控</span>
        </update-con-control-node>
      </div>
      <!-- 避免气候、交叉施工等外部因素影响 -->
      <div class="carate-qe-main-p"
           style="margin-bottom: 30px;width:98%"
           v-show="getExtrinsicFactorsShow">
        <update-extrinsic-factors-node class="material-edit-p"
                                       ref="extrinsic"
                                       :oldExtrinsicFactorsDataArr="extrinsicFactorsArr"
                                       style="padding-top: 0px;padding-bottom: 25px;margin-bottom: 20px;"
                                       @getExtrinsicFactorsData="getExtrinsicFactorsData">
          <span slot="title">避免气候、交叉施工等外部因素影响</span>
        </update-extrinsic-factors-node>
      </div>
      <!-- 成品抽检 -->
      <div class="carate-qe-main-p"
           style="margin-bottom: 30px;width:98%"
           v-show="getProSpotCheckShow">
        <update-product-spot-check class="material-edit-p"
                                   ref="spot"
                                   :oldProCheckPicDataArr="proCheckPicDataArr"
                                   :oldProCheckFileList="proCheckFileList"
                                   @getProSpotCheckDataArr="getProSpotCheckDataArr"
                                   style="padding-top: 0px;padding-bottom: 20px;">
          <span slot="title">成品抽检</span>
          <template slot="checkInfo">
            <div class="create-title-p">
              <input type="text"
                     placeholder="请输入送检检测机构名称"
                     v-model="proCheckInstitutionName" />
            </div>
            <div class="create-title-p">
              <input type="text"
                     placeholder="请输入检测结果描述"
                     v-model="proCheckResult" />
            </div>
          </template>
        </update-product-spot-check>
      </div>
      <!-- 信息反馈 -->
      <div class="carate-qe-main-p"
           style="margin-bottom: 30px;width:98%"
           v-show="getInfoFeedbackShow">
        <update-info-feedback class="material-edit-p"
                              ref="info"
                              :oldInfoFbPicArr="infoFeedbackPicArr"
                              :infoFileType="infoFileType"
                              :oldInfoFbFileList="oldInfoFbFileList"
                              @getInfoFeedbackDataArr="getInfoFeedbackDataArr"
                              style="padding-top: 0px;padding-bottom: 20px;">
          <span slot="title">信息反馈</span>
          <span slot="remark">上传《现场品控工程师信息反馈表》(图片或PDF二选一上传)&nbsp;</span>
        </update-info-feedback>
      </div>
      <div class="carate-qe-main-p">
        <div class="qe-btn-p">
          <p>取消</p>
          <p @click="create"
             v-show="createButtonShow">保存</p>
        </div>
      </div>

      <aside-right @scrollToCover="scrollToCover"
                   @scrollToScene="scrollToScene"
                   @scrollToQuality="scrollToQuality"
                   @scrollToMaterial="scrollToMaterial"
                   @scrollToExtrinsic="scrollToExtrinsic"
                   @scrollToSpot="scrollToSpot"
                   @scrollToInfo="scrollToInfo"
                   @scrollToTop="scrollToTop" />
    </div>
  </div>
</template>

<script>
import "../../../../html/pages/originality/createQe/testQE.scss"

import ImageUpload from "../../../../components/imageUpload/ImageUpload"
import asideRight from "./components/newAsideRight.vue"

import { jxjAddQEReportV2, getJxjPostDetail } from "../../../../api/index"
import UpdateExtrinsicFactorsNode from './components/updateExtrinsicFactorsNode.vue'
import UpdateQeUploadFile from './components/updateQeUploadFile'
import UpRawMaterialEnter from './components/upRawMaterialEnter.vue'
import UpdateConControlNode from './components/updateConControlNode.vue'
import UpdateProductSpotCheck from './components/updateProductSpotCheck.vue'
import UpdateInfoFeedback from './components/updateInfoFeedback.vue'
import UpdateSceneStandardMake from './components/updateSceneStandardMake.vue'

export default {
  name: 'newUpdateQE',
  data () {
    return {
      id: "",
      qeId: "",
      oldData: {},
      params: {//总参
        ForumsId: "",
        Name: "",
        Content1: [],
        //token: "fb4b719afa2db43ed0f03e1446672cd959fd1070"
      },
      sceneStandardMakeNode: {
        nodeName: "现场标样制作",
        subnodelist: []
      },
      sceneStandardMakeArr: [],
      sceneStandardMakeNodeCount: 2,// 现场标样制作，当前模板写死，选项节点数量固定
      constructionControlData: {
        nodeName: "施工过程管控",
        subnodelist: []
      },
      constructionControlDataArr: [],
      conControlNodeCount: 19,// 施工过程管控，当前模板写死，选项节点数量固定
      extrinsicFactorsData: {
        nodeName: "避免气候、交叉施工等外部因素影响",
        subnodelist: []
      },
      extrinsicFactorsArr: [],
      extrinsicFactorsNodeCount: 4,// 外部因素，当前模板写死，选项节点数量固定
      title: "",
      picDataArr: [],//基础检查 原图
      extraData: {//基础检查 文件
        type: 'file',
        file: ''
      },
      extraFileList: [],//基础检查 回显文件
      baseFileType: "",//基础检查 文件类型
      rowRadioValue: 0,//原材料储存 品质
      rowRadioRemark: '',//原材料储存 选项描述
      rowPicDataArr: [],//原材料储存 原图
      checkInstitutionName: "",//原材料进场 检检测机构名称
      checkResult: "",// 原材料进场 检测结果描述
      rowCheckPicDataArr: [],//原材料抽检 原图
      rowCheckFileData: {//原材料抽检 文件
        type: 'file',
        file: ''
      },
      rowCheckFileList: [],//原材料抽检 回显文件
      proCheckInstitutionName: "",//成品抽检 检检测机构名称
      proCheckResult: "",//成品抽检 检测结果描述
      proCheckPicDataArr: [],//成品抽检原图
      proCheckFileData: {//成品抽检文件
        type: 'file',
        file: ''
      },
      proCheckFileList: [],//成品抽检 回显文件
      createButtonShow: false,
      //nodeState 1-良好 2-预警 3-异常
      constructionControlDefaultArr: [
        {
          nodeName: "1.材料用量和配比",
          subnodelist: [
            {
              nodeName: "a.施工现场材料用量和配比需符合销售订单量、需符合公司标准；",
              remark: "",
              nodeState: 0
            }
          ]
        },
        {
          nodeName: "2.材料搅拌",
          subnodelist: [
            {
              nodeName: "a.搅拌设备需符合公司要求；",
              remark: "",
              nodeState: 0
            },
            {
              nodeName: "b.搅拌需充分、均匀；",
              remark: "",
              nodeState: 0
            }
          ]
        },
        {
          nodeName: "3.基础处理剂",
          subnodelist: [
            {
              nodeName: "a.滚涂/喷涂均匀，无露底、无积料；",
              remark: "",
              nodeState: 0
            },
            {
              nodeName: "b.搅拌需充分、均匀；",
              remark: "",
              nodeState: 0
            }
          ]
        },
        {
          nodeName: "4.弹性底层摊铺（检查接缝、平整度、密实度）",
          subnodelist: [
            {
              nodeName: "a.底层颗粒无明显松动、脱落、过水失胶现象；",
              remark: "",
              nodeState: 0
            },
            {
              nodeName: "b.底层颗粒表观平整密实，接缝无明显高低，无裂纹，不毛糙，按压有强度；",
              remark: "",
              nodeState: 0
            },
            {
              nodeName: "c.底层厚度控制达到设计要求；",
              remark: "",
              nodeState: 0
            }
          ]
        },
        {
          nodeName: "5.中间层",
          subnodelist: [
            {
              nodeName: "a.要求表面无漏底、无麻面、无凹凸、无明显接缝、无堆积料；",
              remark: "",
              nodeState: 0
            },
            {
              nodeName: "b.要求表面平整无积水，闭水试验，2m靠尺，积水深度小于3mm；",
              remark: "",
              nodeState: 0
            },
            {
              nodeName: "c.中间层应完全干燥（多点测试，湿度小于6%）；",
              remark: "",
              nodeState: 0
            },
            {
              nodeName: "d.要求表面无起鼓、无气泡。",
              remark: "",
              nodeState: 0
            }
          ]
        },
        {
          nodeName: "6.面层",
          subnodelist: [
            {
              nodeName: "a.查看施工天气，下雨前12h不施工；环境温度高于35℃、低于5℃时不施工；",
              remark: "",
              nodeState: 0
            },
            {
              nodeName: "b.滚涂型面层表观均匀不发花、场地洁净、无漏底、无接缝、无滚筒印、无堆积、无气泡；",
              remark: "",
              nodeState: 0
            },
            {
              nodeName: "c.喷涂型面层要求胶水包裹均匀饱满，面层颗粒呈包浆状态，无毛糙感，与下层材料粘结牢固，站立目测无明显色差、无漏底；",
              remark: "",
              nodeState: 0
            },
            {
              nodeName: "d.面层混合料需在5-10分钟内用完，严禁使用有结皮现象的混合料，严禁兑水；",
              remark: "",
              nodeState: 0
            },
            {
              nodeName: "e.同种颜色的面层材料若存在不同批号，应分开放置并妥善管理。",
              remark: "",
              nodeState: 0
            },
            {
              nodeName: "f.在进行最后一遍面层施工时，必须使用同一批号的材料，以确保表面颜色的一致性。",
              remark: "",
              nodeState: 0
            },
            {
              nodeName: "g.完工7天后，穿运动鞋脚跟旋转，观察面层颗粒牢固度，是否有颗粒脱落；",
              remark: "",
              nodeState: 0
            }
          ]
        }
      ],
      extrinsicFactorsDefaultArr: [
        {
          nodeName: "1.风速大于5级时，不得喷涂施工；",
          remark: "",
          nodeState: 0
        },
        {
          nodeName: "2.避免夏季高温时段（环境温度＞35℃或地表温度＞40℃）施工，可安排早晚温度较低时段施工作业，以确保施工质量和材料性能；",
          remark: "",
          nodeState: 0
        },
        {
          nodeName: "3.环境湿度大于85%或冬季气温低于10℃时，应暂停施工。如确需施工，必须配备烘干设备以加速干燥过程，确保施工效果；",
          remark: "",
          nodeState: 0
        },
        {
          nodeName: "4.避免交叉施工导致的污染，合理安排施工顺序和区域，确保施工环境的清洁与独立性。",
          remark: "",
          nodeState: 0
        }
      ],
      sceneStandardMakeArrDefaultArr: [
        {
          nodeName: "1.底层表观平整，无裂纹，不毛糙，按压有强度。",
          remark: "",
          nodeState: 0,
          picArr: []
        },
        {
          nodeName: "2.面层颗粒包浆状态，无毛糙感。",
          remark: "",
          nodeState: 0,
          picArr: []
        }
      ],
      infoFeedbackPicArr: [],//信息反馈 图片
      infoFeedbackFileData: {//信息反馈 文件
        type: '',
        file: ''
      },
      infoFileType: "",//信息反馈 文件类型
      oldInfoFbFileList: [],//信息反馈 文件回显
    }
  },
  computed: {
    getSceneStandardMakeShow () {//现场标样制作
      return this.title.length > 0 && (this.picDataArr.length > 0 || this.extraData.file.length > 0)
    },
    getRawMaterialEnterShow () {//原材料进场
      if (!this.getSceneStandardMakeShow) return false;

      if (this.sceneStandardMakeNode.subnodelist.length < 1) {
        return false;
      }
      let subnodeCount = 0
      for (let subnode of this.sceneStandardMakeNode.subnodelist) {
        if (subnode.nodeState > 0 && subnode.remark && subnode.remark.length > 0 && subnode.picArr && subnode.picArr.length > 0) {
          subnodeCount = subnodeCount + 1
        } else {
          return false
        }
      }
      if (subnodeCount === this.sceneStandardMakeNodeCount) {
        return true
      }
      return false
    },
    getRawMaterialCheckShow () {//原材料抽检
      if (!this.getRawMaterialEnterShow) return false;
      if (this.rowRadioValue > 0 && this.rowPicDataArr.length > 0) {
        if (2 == this.rowRadioValue || 3 == this.rowRadioValue) {
          if (this.rowRadioRemark.length < 1) return false
        }
        return true
      }
      return false
    },
    getConControlNodeShow () {//施工过程管控
      if (!this.getRawMaterialCheckShow) return false;
      //console.log("getConControlNodeShow", this);
      return this.rowRadioValue > 0 && this.rowPicDataArr.length > 0 && this.rowCheckPicDataArr.length > 0 &&
          this.checkInstitutionName.length > 0 && this.checkResult.length > 0
    },
    getExtrinsicFactorsShow () {//外部因素
      if (!this.getConControlNodeShow) return false;
      if (this.constructionControlData.subnodelist.length > 0) {
        let subnodeCount = 0
        for (let subnode of this.constructionControlData.subnodelist) {
          if (subnode.subnodelist.length > 0) {
            for (let grandsonNode of subnode.subnodelist) {
              if (grandsonNode.nodeState > 0 && grandsonNode.remark && grandsonNode.remark.length > 0 && grandsonNode.picArr && grandsonNode.picArr.length > 0) {
                subnodeCount = subnodeCount + 1
              } else {
                return false
              }
            }
          } else {
            return false
          }
        }
        if (subnodeCount === this.conControlNodeCount) {
          return true
        }
      } else {
        return false
      }
    },
    getProSpotCheckShow () {//成品抽检
      if (!this.getExtrinsicFactorsShow) return false;

      if (this.extrinsicFactorsData.subnodelist.length > 0) {
        let subnodeCount = 0
        for (let subnode of this.extrinsicFactorsData.subnodelist) {
          if (subnode.nodeState > 0 && subnode.remark && subnode.remark.length > 0 && subnode.picArr && subnode.picArr.length > 0) {
            subnodeCount = subnodeCount + 1
          } else {
            return false
          }
        }
        if (subnodeCount === this.extrinsicFactorsNodeCount) {
          return true
        }
      } else {
        return false
      }
    },
    getInfoFeedbackShow () {//信息反馈
      if (!this.getProSpotCheckShow) return false;
      return this.proCheckPicDataArr.length > 0 && this.proCheckInstitutionName.length > 0 && this.proCheckResult.length > 0
    }
  },
  components: {
    ImageUpload,
    asideRight,
    UpdateExtrinsicFactorsNode,
    UpdateQeUploadFile,
    UpRawMaterialEnter,
    UpdateConControlNode,
    UpdateProductSpotCheck,
    UpdateInfoFeedback,
    UpdateSceneStandardMake,
  },
  methods: {
    async init () {
      let res = await getJxjPostDetail({
        id: this.qeId
      })
      if (res.Type == "Success") {
        if (res.Data.postData.length > 0) {
          let content = res.Data.postData[0].content
          if (content.length) {
            this.oldData = JSON.parse(content)
            // 标题
            this.title = res.Data.title
            for (let node of this.oldData) {
              // 基础检查
              if ("基础检查" == node.nodeName) {
                //判断是PDF还是图片
                if (node.img && node.img.length > 0) {
                  let fileType = node.img[0].split('.').pop().toLowerCase()
                  if ("pdf" == fileType) {
                    this.baseFileType = "PDF"
                    this.extraData.file = node.img[0]
                    let file = {
                      name: "《现场基础情况检查告知函》",
                      url: node.img[0]
                    }
                    this.extraFileList.push(file)
                  } else {
                    this.baseFileType = "IMG"
                    this.picDataArr = node.img
                  }
                }
              }
              // 现场标样制作 
              if ("现场标样制作" == node.nodeName) {
                this.sceneStandardMakeNode.subnodelist = node.subnodelist
                this.sceneStandardMakeArr = node.subnodelist
              }
              // 原材料进场
              if ("原材料进场" == node.nodeName) {
                this.setRawEnterData(node)
              }
              // 施工过程管控
              if ("施工过程管控" == node.nodeName) {
                this.constructionControlData.subnodelist = node.subnodelist
                //console.log("施工过程管控", node.subnodelist)
                this.constructionControlDataArr = node.subnodelist
              }
              // 避免气候、交叉施工等外部因素影响 
              if ("避免气候、交叉施工等外部因素影响" == node.nodeName) {
                this.extrinsicFactorsData.subnodelist = node.subnodelist
                this.extrinsicFactorsArr = node.subnodelist
              }
              // 成品抽检
              if ("成品抽检" == node.nodeName) {
                //console.log("成品抽检", node)
                this.proCheckInstitutionName = node.checkInstitutionName
                this.proCheckResult = node.checkResult
                this.proCheckPicDataArr = node.img
                this.proCheckFileData.file = node.file
                if (node.file && node.file.length > 0) {
                  let file = {
                    name: "检测报告",
                    url: node.file
                  }
                  this.proCheckFileList.push(file)
                }
                // "nodeName": "成品抽检",
                // "img": [
                //     "https://www.iduilv.com/Upload/OOS/e16df6e3e15b49aea32e212b223f173e.png"
                // ],
                // "checkInstitutionName": "测试机构2",
                // "checkResult": "良好",
                // "file": "/Upload/OOS/36f8e89be5cc4229938d7d73f3842ab7.pdf"
              }
              // 信息反馈
              if ("信息反馈" == node.nodeName) {
                //判断是PDF还是图片
                if (node.img && node.img.length > 0) {
                  let fileType = node.img[0].split('.').pop().toLowerCase()
                  if ("pdf" == fileType) {
                    this.infoFileType = "PDF"
                    this.infoFeedbackFileData.file = node.img[0]
                    let file = {
                      name: "《现场品控工程师信息反馈表》",
                      url: node.img[0]
                    }
                    this.oldInfoFbFileList.push(file)
                  } else {
                    this.infoFileType = "IMG"
                    if (node.img && node.img[0] && node.img[0].length > 0) {
                      this.infoFeedbackPicArr = node.img
                    }
                  }
                }
              }
            }
            // 默认模板
            if (this.constructionControlDataArr.length < 1) {
              this.constructionControlData.subnodelist = this.constructionControlDefaultArr
              this.constructionControlDataArr = this.constructionControlDefaultArr
            } else if (this.constructionControlDataArr[0].subnodelist && this.constructionControlDataArr[0].subnodelist.length < 1) {
              this.constructionControlData.subnodelist = this.constructionControlDefaultArr
              this.constructionControlDataArr = this.constructionControlDefaultArr
            }
            //console.log("constructionControlDefaultArr", this.constructionControlDataArr)
            if (this.extrinsicFactorsArr.length < 1) {
              this.extrinsicFactorsData.subnodelist = this.extrinsicFactorsDefaultArr
              this.extrinsicFactorsArr = this.extrinsicFactorsDefaultArr
            } else if (this.extrinsicFactorsArr[0].subnodelist && this.extrinsicFactorsArr[0].subnodelist.length < 1) {
              this.extrinsicFactorsData.subnodelist = this.extrinsicFactorsDefaultArr
              this.extrinsicFactorsArr = this.extrinsicFactorsDefaultArr
            }
            if (this.sceneStandardMakeArr.length < 1) {
              this.sceneStandardMakeNode.subnodelist = this.sceneStandardMakeArrDefaultArr
              this.sceneStandardMakeArr = this.sceneStandardMakeArrDefaultArr
            } else if (this.sceneStandardMakeArr[0].subnodelist && this.sceneStandardMakeArr[0].subnodelist.length < 1) {
              this.sceneStandardMakeNode.subnodelist = this.sceneStandardMakeArrDefaultArr
              this.sceneStandardMakeArr = this.sceneStandardMakeArrDefaultArr
            }
            //console.log("extrinsicFactorsDefaultArr", this.extrinsicFactorsArr)
            this.createButtonShow = true
          }
        }
      } else if (reportRes.Type == 'Error') {
        this.$layer.alert(reportRes.Content);
      }
    },
    // 原材料
    setRawEnterData (node) {
      for (let subnode of node.subnodelist) {
        if ("原材料储存" == subnode.nodeName) {
          this.rowPicDataArr = subnode.img
          this.rowRadioValue = subnode.nodeState
          this.rowRadioRemark = subnode.remark
        }
        if ("原材料抽检" == subnode.nodeName) {
          this.rowCheckPicDataArr = subnode.img
          this.checkInstitutionName = subnode.checkInstitutionName
          this.checkResult = subnode.checkResult
          this.rowCheckFileData.file = subnode.file
          if (subnode.file && subnode.file.length > 0) {
            let file = {
              name: "检测报告",
              url: subnode.file
            }
            this.rowCheckFileList.push(file)
          }
        }
      }
    },
    getReportDataArr (picDataList, extraDataObj, type) {
      //   console.log("getReportDataArr", picDataList)
      //   console.log("getReportDataArr", extraDataObj)
      this.picDataArr = picDataList
      this.extraData = extraDataObj
      this.baseFileType = type
      //console.log("getReportDataArr", this)
    },
    getSceneStandardMakeData (sceneStandardMakeDataArr) {
      //console.log("getSceneStandardMakeData", sceneStandardMakeDataArr)
      this.sceneStandardMakeNode.subnodelist = sceneStandardMakeDataArr
      //console.log("getSceneStandardMakeData", this.sceneStandardMakeNode)
    },
    getRowEnterDataArr (rowPicDataList, rowCheckPicDataList, rowCheckFile) {
      //   console.log("getRowEnterDataArr", rowPicDataList)
      //   console.log("getRowEnterDataArr", rowCheckPicDataList)
      //   console.log("getRowEnterDataArr", rowCheckFile)
      this.rowPicDataArr = rowPicDataList
      this.rowCheckPicDataArr = rowCheckPicDataList
      this.rowCheckFileData = rowCheckFile
    },
    getConstructionControlData (constructionControlData) {
      //console.log("getConstructionControlData", constructionControlData)
      this.constructionControlData.subnodelist = constructionControlData
      console.log("getConstructionControlData", this.constructionControlData)
    },
    getExtrinsicFactorsData (extrinsicFactorsDataArr) {
      //console.log("getExtrinsicFactorsData", extrinsicFactorsDataArr)
      this.extrinsicFactorsData.subnodelist = extrinsicFactorsDataArr
      //console.log("getExtrinsicFactorsData", this.extrinsicFactorsData)
    },
    getProSpotCheckDataArr (proCheckPicDataArr, proCheckFileData) {
      //   console.log("getReportDataArr", picDataList)
      //   console.log("getReportDataArr", extraDataObj)
      this.proCheckPicDataArr = proCheckPicDataArr
      this.proCheckFileData = proCheckFileData
    },
    getInfoFeedbackDataArr (infoFeedbackPicArr, infoFeedbackFileData, type) {
      //   console.log("getInfoFeedbackDataArr", infoFeedbackPicArr)
      //   console.log("getInfoFeedbackDataArr", infoFeedbackFileData)
      this.infoFeedbackPicArr = infoFeedbackPicArr
      this.infoFeedbackFileData = infoFeedbackFileData
      this.infoFileType = type
      //console.log("getInfoFeedbackDataArr", this)
    },
    async create () {
      /*
      **数据整合
      */
      if (!this.title) return this.$layer.alert("请填写QE报告标题！")
      if (this.picDataArr.length === 0 && this.extraData.file.length === 0) return this.$layer.alert("请上传《现场基础情况检查告知函》！")
      // 现场标样制作：只在显示时验证
      if (this.getSceneStandardMakeShow) {
        if (this.sceneStandardMakeNode.subnodelist.length > 0) {
          for (let subnode of this.sceneStandardMakeNode.subnodelist) {
            if(!subnode.picArr || subnode.picArr.length < 1){
              return this.$layer.alert("请上传现场标样制作'"+subnode.nodeName+"'图片！")
            }
            if(subnode.nodeState < 1){
              return this.$layer.alert("请完成现场标样制作'"+subnode.nodeName+"'节点状态！")
            }
            if(!subnode.remark || subnode.remark.length < 1){
              return this.$layer.alert("请完成现场标样制作'"+subnode.nodeName+"'描述信息！")
            }
          }
        }else {
          return this.$layer.alert("请完善现场标样制作内容！")
        }
      }
      // 原材料进场：只在显示时验证
      if (this.getRawMaterialEnterShow) {
        if(!this.rowPicDataArr || this.rowPicDataArr.length < 1){
          return this.$layer.alert("请上传原材料储存图片！")
        }
        if(!this.rowRadioValue || this.rowRadioValue < 1){
          return this.$layer.alert("请完成原材料储存节点状态！")
        }
        if(!this.rowRadioRemark || this.rowRadioRemark.length < 1){
          return this.$layer.alert("请完成原材料储存描述！")
        }
        // if (this.rowRadioValue > 0 || this.rowPicDataArr.length > 0) {
          // if (2 == this.rowRadioValue || 3 == this.rowRadioValue) {
          //   if (this.rowRadioRemark.length < 1) return this.$layer.alert("请完善原材料储存内容！")
          // }
        // }
      }
      // 原材料抽检：依赖原材料进场显示
      if (this.getRawMaterialCheckShow) {

        if(!this.rowCheckPicDataArr || this.rowCheckPicDataArr.length < 1){
          return this.$layer.alert("请上传原材料抽检图片！")
        }
        if(!this.checkInstitutionName || this.checkInstitutionName.length < 1){
          return this.$layer.alert("请完成原材料抽检送检机构名称！")
        }
        if(!this.checkResult || this.checkResult.length < 1){
          return this.$layer.alert("请完成原材料抽检送检检测结果描述！")
        }


        // if (this.rowCheckPicDataArr.length > 0 || this.checkInstitutionName.length > 0 || this.checkResult.length > 0) {
        //   if (this.rowCheckPicDataArr.length < 1 || this.checkInstitutionName.length < 1 || this.checkResult.length < 1) {
        //     return this.$layer.alert("请完善原材料抽检内容！")
        //   }
        // }
      }
      //施工过程管控
      if (this.getConControlNodeShow) {
        if (this.constructionControlData.subnodelist.length > 0) {
          // let subnodeCount = 0
          for (let subnode of this.constructionControlData.subnodelist) {
            if (subnode.subnodelist.length > 0) {
              for (let grandsonNode of subnode.subnodelist) {

                if(!grandsonNode.picArr || grandsonNode.picArr.length < 1){
                  return this.$layer.alert("请上传施工过程管控'"+subnode.nodeName+"_"+grandsonNode.nodeName+"'图片！")
                }
                if(grandsonNode.nodeState < 1){
                  return this.$layer.alert("请完成施工过程管控'"+subnode.nodeName+"_"+grandsonNode.nodeName+"'节点状态！")
                }
                if(!grandsonNode.remark || grandsonNode.remark.length < 1){
                  return this.$layer.alert("请完成施工过程管控'"+subnode.nodeName+"_"+grandsonNode.nodeName+"'描述信息！")
                }

                // if (grandsonNode.nodeState > 0 && grandsonNode.remark && grandsonNode.remark.length > 0 && grandsonNode.picArr && grandsonNode.picArr.length > 0) {
                //   subnodeCount = subnodeCount + 1
                // } else {
                //   return this.$layer.alert("请完善施工过程管控内容！")
                // }
              }
            }else {
              return this.$layer.alert("请完善施工过程管控内容！")
            }
          }

        } else {
            return this.$layer.alert("请完善施工过程管控内容！")
          }
      }

      //外部因素
      if (this.getExtrinsicFactorsShow) {
        if (this.extrinsicFactorsData.subnodelist.length > 0) {
          // let subnodeCount = 0
          for (let subnode of this.extrinsicFactorsData.subnodelist) {

            if(!subnode.picArr || subnode.picArr.length < 1){
              return this.$layer.alert("请上传外部因素'"+subnode.nodeName+"'图片！")
            }
            if(subnode.nodeState < 1){
              return this.$layer.alert("请完成外部因素'"+subnode.nodeName+"'节点状态！")
            }
            if(!subnode.remark || subnode.remark.length < 1){
              return this.$layer.alert("请完成外部因素'"+subnode.nodeName+"'描述信息！")
            }
            // if (subnode.nodeState > 0 && subnode.remark && subnode.remark.length > 0 && subnode.picArr && subnode.picArr.length > 0) {
            //   subnodeCount = subnodeCount + 1
            // } else {
            //   return this.$layer.alert("请完善外部因素内容！")
            // }
          }
          // if (subnodeCount !== this.extrinsicFactorsNodeCount) {
          //   return this.$layer.alert("请完善外部因素内容！")
          // }
        } else {
          return this.$layer.alert("请完善外部因素内容！")
        }

      }

      // 成品抽检：只在显示时验证
      if (this.getProSpotCheckShow) {
        // if (this.proCheckPicDataArr.length > 0 || this.proCheckInstitutionName.length > 0 || this.proCheckResult.length > 0) {
        //   if (this.proCheckPicDataArr.length < 1 || this.proCheckInstitutionName.length < 1 || this.proCheckResult.length < 1) {
        //     return this.$layer.alert("请完善成品抽检内容！")
        //   }
        // }


        if(!this.proCheckPicDataArr || this.proCheckPicDataArr.length < 1){
          return this.$layer.alert("请上传成品抽检图片！")
        }
        if(!this.proCheckInstitutionName || this.proCheckInstitutionName.length < 1){
          return this.$layer.alert("请完成成品抽检检检测机构名称！")
        }
        if(!this.proCheckResult || this.proCheckResult.length < 1){
          return this.$layer.alert("请完成成品抽检检测结果描述！")
        }

        // if(!(this.proCheckPicDataArr.length > 0 && this.proCheckInstitutionName.length > 0 && this.proCheckResult.length > 0)){
        //   return this.$layer.alert("请完善成品抽检内容！")
        // }
      }
      // // 信息反馈
      // if (this.getInfoFeedbackShow) {
      // }

      let params = this.params
      //console.log("create", params)
      params.Name = this.title
      params.ForumsId = this.id
      let content1 = []

      // 基础检查
      let baseCheckUrl = []
      if (this.picDataArr.length > 0 && "IMG" == this.baseFileType) {
        baseCheckUrl = this.picDataArr
      } else {
        baseCheckUrl.push(this.extraData.file);
      }
      let baseCheck = {
        nodeName: "基础检查",
        img: baseCheckUrl
      }
      content1.push(baseCheck);
      // 现场标样制作（只在显示时添加数据）
      if (this.getSceneStandardMakeShow) {

        content1.push(this.sceneStandardMakeNode);
      }
      // 原材料进场（只在显示时添加数据）
      if (this.getRawMaterialEnterShow) {

        let rawEnter = {
          nodeName: '原材料进场',
          img: [],
          nodeState: 0,
          subnodelist: [
            {
              nodeName: '原材料储存',
              img: this.rowPicDataArr,
              nodeState: this.rowRadioValue,
              remark: this.rowRadioRemark
            },
            {
              nodeName: '原材料抽检',
              img: this.rowCheckPicDataArr,
              checkInstitutionName: this.checkInstitutionName,
              checkResult: this.checkResult,
              file: this.rowCheckFileData.file,
            }
          ]
        }
        //console.log("file", this.rowCheckFileData)
        content1.push(rawEnter);
      }
      // 施工过程管控（只在显示时添加数据）
      if (this.getConControlNodeShow) {

        content1.push(this.constructionControlData);
      }
      // 避免气候、交叉施工等外部因素影响
      // 外部因素（只在显示时添加数据）
      if (this.getExtrinsicFactorsShow) {
        content1.push(this.extrinsicFactorsData);
      }
      // 成品抽检（只在显示时添加数据）
      if (this.getProSpotCheckShow) {

        let proCheck = {
          nodeName: '成品抽检',
          img: this.proCheckPicDataArr,
          checkInstitutionName: this.proCheckInstitutionName,
          checkResult: this.proCheckResult,
          file: this.proCheckFileData.file,
        }
        content1.push(proCheck);
      }
      // 信息反馈（只在显示时添加数据）
      if (this.getInfoFeedbackShow) {

        let infoCheckUrl = []
        if (this.infoFeedbackPicArr.length > 0 && "IMG" == this.infoFileType) {
          infoCheckUrl = this.infoFeedbackPicArr
        } else {
          infoCheckUrl.push(this.infoFeedbackFileData.file);
        }
        let infoCheck = {
          nodeName: "信息反馈",
          img: infoCheckUrl
        }
        content1.push(infoCheck);
      }
      // 封装
      let contentObj = {
        type: "4",
        data: JSON.stringify(content1)
      }
      params.Content1.push(contentObj)
      //console.log("create", params)
      // 创建qe报告
      let reportRes = await jxjAddQEReportV2(params)
      if (reportRes.Type == 'Success') {
        this.$layer.msg(reportRes.Content, (msg) => {
          this.$layer.close(msg)
          this.$router.push({ name: "jxjDetail", params: { id: this.$route.params.id } })
        })
      } else if (reportRes.Type == 'Error') {
        this.$layer.alert(reportRes.Content);
      }
    },
    scrollToCover () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.cover.offsetTop - 60
    },
    scrollToScene () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.scene.$el.offsetTop - 60
    },
    scrollToQuality () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.quality.$el.offsetTop - 60
    },
    scrollToMaterial () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.material.$el.offsetTop - 60
    },
    scrollToExtrinsic () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.extrinsic.$el.offsetTop - 60
    },
    scrollToSpot () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.spot.$el.offsetTop - 60
    },
    scrollToInfo () {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.info.$el.offsetTop - 60
    },
    scrollToTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
  },
  created () {
    this.id = this.$route.params.id
    this.qeId = this.$route.params.qeId
    this.init()
  }
}
</script>

